/* Graphic Tee Bar cart helper.
   - Keeps each print line the same quantity as its blank line (the blank drives it).
   - Shows a friendly name ("Red Hoodie", "Print: ...") instead of the product title.
   - Hides quantity and remove controls on print lines.
   Works on the cart page and in the cart drawer without editing those templates. */
(() => {
  if (window.__gtbCart) return;
  window.__gtbCart = true;
  const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';
  let busy = false;
  let timer = null;

  const getCart = async () => (await fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })).json();

  const pairUp = async (cart) => {
    const groups = {};
    cart.items.forEach((item) => {
      const id = item.properties && item.properties._gtb_id;
      if (id) (groups[id] ||= {})[item.properties._gtb_role] = item;
    });
    const updates = {};
    Object.values(groups).forEach((g) => {
      if (g.print && !g.blank) updates[g.print.key] = 0;
      else if (g.print && g.blank && g.print.quantity !== g.blank.quantity) updates[g.print.key] = g.blank.quantity;
    });
    if (!Object.keys(updates).length) return false;
    await fetch(cartUrl() + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    return true;
  };

  const decorate = (cart) => {
    document.querySelectorAll('tr.cart-item').forEach((row) => {
      const match = /(?:CartItem|CartDrawer-Item)-(\d+)$/.exec(row.id || '');
      const item = match && cart.items[Number(match[1]) - 1];
      if (!item || !item.properties || !item.properties._gtb_id) return;
      const label = item.properties._gtb_label;
      const name = row.querySelector('.cart-item__name');
      if (label && name && name.textContent.trim() !== label) name.textContent = label;
      if (item.properties._gtb_role === 'print') {
        row.querySelectorAll('.cart-item__quantity').forEach((q) => { q.style.visibility = 'hidden'; q.style.pointerEvents = 'none'; });
      }
    });
  };

  const run = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await getCart();
      if (!cart.items.some((i) => i.properties && i.properties._gtb_id)) { busy = false; return; }
      if (await pairUp(cart)) { window.location.reload(); return; }
      decorate(cart);
    } catch (e) { /* the cart still works without these touches */ }
    busy = false;
  };
  const soon = () => { clearTimeout(timer); timer = setTimeout(run, 350); };

  const nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const url = String(args[0] && args[0].url ? args[0].url : args[0]);
    const result = nativeFetch.apply(this, args);
    if (/\/cart\/(change|update|add)/.test(url) && !busy) result.then(soon).catch(() => {});
    return result;
  };
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', soon);
})();
